import { render, staticRenderFns } from "./FormTag.vue?vue&type=template&id=88e2ecac&"
import script from "./FormTag.vue?vue&type=script&lang=js&"
export * from "./FormTag.vue?vue&type=script&lang=js&"
import style0 from "./FormTag.vue?vue&type=style&index=0&id=88e2ecac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports